import { render, staticRenderFns } from "./team-member-profile.vue?vue&type=template&id=32da4a4d&"
import script from "./team-member-profile.vue?vue&type=script&lang=js&"
export * from "./team-member-profile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports